import React from 'react'
import PropTypes from 'prop-types'

const CallControls = ({ callState, onStart, onEnd }) => (
  <>
    <button className="vc-btn vc-btn-start" onClick={onStart} disabled={callState === 'active'}>
      통화 요청
    </button>
    <button className="vc-btn vc-btn-end" onClick={onEnd} disabled={callState !== 'active'}>
      통화 끊기
    </button>
  </>
)

CallControls.propTypes = {
  callState: PropTypes.string,
  onStart: PropTypes.func,
  onEnd: PropTypes.func,
}

export default CallControls
